import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CementProduct,
  CementProductDeliveryOption,
  CementProductDeliverySummary,
  cementProductDeliverySummaryItems,
  cementProductNormalizeIncoterm,
} from '../models/cement-product';
import { ConfigService } from '../shared/utils/http';
import { HttpClient } from '@angular/common/http';

const CEMENTO_BASE = 'cemento/';

const PRODUCT_IMAGE_MAP: Record<string, string> = {
  'saco ar': 'assets/img/Pallet_AR.svg',
  'saco especial': 'assets/img/Pallet_Especial.svg',
};

export interface CementoProductsQuery {
  comuna: string;
  region: number;
}

interface CementProductGroupedResponse {
  nombre_publicacion?: {
    texto?: string;
  };
  delivery_summary?: CementProductDeliverySummary;
  items: CementProductDeliveryOption[];
}

@Injectable({ providedIn: 'root' })
export class CementoService {
  private readonly http: ConfigService;

  constructor(private readonly client: HttpClient) {
    this.http = new ConfigService(client);
  }

  getProducts(query: CementoProductsQuery): Observable<CementProduct[]> {
    return this.http
      .post<CementProductGroupedResponse[]>(`${CEMENTO_BASE}products/by-centro/`, {
        ...query,
        grouped: true,
      })
      .pipe(map((response) => this.mapGroupedProducts(response)));
  }

  private mapGroupedProducts(response: CementProductGroupedResponse[]): CementProduct[] {
    return response
      .filter((group) => Array.isArray(group.items) && group.items.length > 0)
      .map((group) => {
        const first = group.items[0];
        const publicationText = String(group.nombre_publicacion?.texto ?? '').trim();
        const selectedIncoterm = cementProductNormalizeIncoterm(first.incoterms);
        const imageUrl = PRODUCT_IMAGE_MAP[String(first.producto ?? '').trim().toLowerCase()];
        const product: CementProduct = {
          ...first,
          nombre_publicacion: {
            texto: publicationText,
            tipo_despacho: '',
          },
          delivery_options: group.items,
          delivery_summary: group.delivery_summary,
          selected_incoterm: selectedIncoterm,
          ...(imageUrl ? { image_url: imageUrl } : {}),
        };
        product.delivery_badges = cementProductDeliverySummaryItems(product).map((item) => ({
          label: item.short_label,
          available: item.available,
        }));
        return product;
      });
  }
}
